import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from 'react';
import { Box, Button, InputBase, Chip } from '@mui/material';
import { Add } from '@mui/icons-material';
import { csn } from '@one-vision/utils';
import { useStyles } from './dz-pre-sold-dialog.styles';
export const DzCouponInput = ({ loading, setIsLoading, coupon, setCoupon, setInvoice, dispatch, actions, getRequest, }) => {
    const classes = useStyles();
    const [inputShow, setInputShow] = useState(false);
    const submitCoupon = async (couponId) => {
        var _a, _b;
        setIsLoading(true);
        try {
            const { data: invoiceData } = await getRequest(couponId);
            setInvoice(invoiceData.data);
            dispatch(actions.updateSnackbar({
                type: 'success',
                text: 'Coupon is applied',
            }));
            setInputShow(false);
        }
        catch (err) {
            const error = err;
            if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.errors[0].title) {
                dispatch(actions.updateSnackbar({
                    type: 'error',
                    text: (_b = error.response) === null || _b === void 0 ? void 0 : _b.data.errors[0].title,
                }));
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    const submitCouponHandler = useCallback(() => {
        submitCoupon(coupon);
    }, [coupon]);
    const couponShowHandler = useCallback(() => {
        setInputShow(true);
    }, [setInputShow]);
    const couponHandler = useCallback((e) => {
        setCoupon(e.target.value);
    }, [setCoupon]);
    const couponDeleteHandler = useCallback(() => {
        setCoupon('');
        submitCoupon('');
    }, [coupon, submitCoupon]);
    return (_jsxs(Box, Object.assign({ className: classes.couponLine, display: "flex", justifyContent: "space-between", alignItems: "center" }, { children: [!inputShow && !coupon && (_jsxs(Button, Object.assign({ className: classes.coupon, onClick: couponShowHandler }, { children: [_jsx(Add, {}), " Add coupon code"] }))), inputShow && (_jsxs(Box, Object.assign({ className: csn(classes.couponInputWrapper, [
                    classes.couponInputWithText,
                    coupon,
                ]) }, { children: [_jsx(InputBase, { placeholder: "Add coupon code", value: coupon, onChange: couponHandler, autoFocus: true, className: classes.couponInput, inputProps: { 'data-testid': 'coupon-input' } }), _jsx(Button, Object.assign({ disabled: loading, className: classes.applyCoupon, onClick: submitCouponHandler }, { children: "Apply" }))] }))), !inputShow && coupon && (_jsx(Chip, { className: classes.chipCoupon, label: coupon, onDelete: couponDeleteHandler }))] })));
};
